<template>
  <div class="helpTools" :style="isIphone || isHarmony?'':'bottom:48px'">
    <!-- <div class="title">
      <div class="blue-line"></div>
      自助工具
    </div> -->
    <div class="container">
      <div
        class="container-item"
        v-for="(item, index) in list" 
        :key="index"
        @click="item.click()"
      >
        <!-- <img :src="item.img" alt=""> -->
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed:{
    isIphone(){
      console.log(navigator.userAgent,12312313);
      return /iphone/gi.test(navigator.userAgent)&& (screen.height >= 812)
    },
    isHarmony(){
      console.log(navigator.userAgent,12312313);
      return /OpenHarmony/gi.test(navigator.userAgent)
    },
  },
}
</script>

<style lang="scss">
.helpTools {
  // width: calc(100% - 30px);
  width: 100vw;
  background: #F6F6F6;
  position: absolute;
  bottom: 74px;
  left: 0;
  // border-radius: 5px;
  padding: 8px 12px;
  .title {
    padding: 10px 0;
    font-size: 15px;
    font-weight: bold;
    .blue-line {
      margin-right: 5px;
      vertical-align: baseline;
      display: inline-block;
      width: 3px;
      height: 12px;
      border-radius: 10px;
      background-color: #3296FA;
    }
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    // padding: 0 0 0 10px;
    .container-item {
      // margin: 10px 15px 0 15px;
      margin-right: 8px;
      width: 71.75px;
      // width: calc(100vw - 303px);
      height: 28px;
      background: #FFFFFF;
      border-radius: 4px;
      font-size: 13px;
      color: #696969;
      text-align: center;
      line-height: 28px;
      img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      // div {
      //   margin-top: 6px;
      //   font-size: 12px;
      // }
    }
  }
}
</style>
